<template>
  <div class="window select-workers-window" v-show="isVisible">
    <img src="../image/ajax-loader.gif" v-show="waitingApiRequestsCount != 0"
         style="margin: 0; position: absolute; top: 50%; left: 50%; margin-right: -50%; transform: translate(-50%, -50%); z-index: 10">
    <span class="close" title="Закрыть" @click="closeWindow"><img src="../image/cancel.svg"></span>
    <div class="head-block">
      <div class="window-title">Назначить рабочего</div>
      <div class="conditions">
        <span class="service-name">{{ name }}</span>
        <span>{{ serviceTime }}</span>
        <span>{{ categoryName }}</span>
        <span>{{ duration }}</span><br>
        <span class="quantity">Необходимое количество: {{ count }}</span>
      </div>
    </div>
    <div class="form">
      <div class="search">
        <span class="icon"><i class="fa fa-search"></i></span>
        <fieldset><input type="text" placeholder="ФИО или телефон" v-model="workerNameOrWorkerPhoneFilter"></fieldset>
      </div>
      <div class="workers-list">
        <div class="workers-region-group"
             :class="{'active-region': district == currentServiceDistrict}"
             v-for="[district, workersByDistrict] in filteredAndGroupedByDistrictAvailableWorkers">
          <div class="workers-region-title">{{ district == currentServiceDistrict ? `В этом же районе (${district})` : district }}:</div>
          <label class="item" v-for="worker in workersByDistrict" :class="{'free-worker': worker.completedService}">
            <span class="checkbox">
              <input type="checkbox" @click="addOrRemoveWorker(worker)" v-model.lazy="worker.selected">
            </span>
            <span class="name">{{ worker.surname + ' ' + worker.name + ' ' + worker.patronymic }}</span>
            <!--<span v-if="worker.probationEndDate != null && worker.probationEndDate > new Date().getTime()"-->
                  <!--class="beginner">новичок</span>-->
            <span v-if="worker.startingDebt > 0" class="beginner">новичок</span>
            <div class="rating">
              <div class="rating-wrapper">
                <div class="filling" :style="'width: ' + worker.rating * 20 + '%'"></div>
                <div class="stars"></div>
              </div>
            </div>
            <div>
              <span class="category">{{ getWorkerCategories(worker) }}</span><span class="phone">{{ worker.phone }}</span>
            </div>
            <div>
              <span class="area">{{worker.endDistrictService}}</span><span class="address">{{getShortAddress(worker.address)}}</span><span class="time">{{worker.endOfService}}</span>
            </div>
          </label>
        </div>
      </div>
      <div class="buttons">
        <div class="selected-numb">
          Выбрано: {{ selectedWorkers.length }}
        </div>
        <button type="button" class="save-button" @click="appoint">Назначить</button>
      </div>
    </div>
  </div>
</template>
<script>
  import api from '@/api'
  import utils from '@/utils'

  export default {
  name: 'WorkerList',

  props: ['isVisible', 'type', 'serviceArrayFromOrder', 'serviceArrayIndex', 'categoryName', 'categoryId', 'isCash'],

  data () {
    return {
      availableWorkers: [],
      workerNameOrWorkerPhoneFilter: '',
      serviceArray: []
    }
  },

  computed: {
    waitingApiRequestsCount () {
      return this.$store.getters.waitingApiRequestsCount
    },

    workersOnCurrentOrder: {
      get () {
        return this.$store.getters.allAppointedWorkers
      }
    },

    currentServiceDistrict() {
      return this.serviceArray[0].endDistrict;
    },

    filteredAndGroupedByDistrictAvailableWorkers() {
      let workers;

      if (!this.workerNameOrWorkerPhoneFilter) {
        workers = utils.distinctBy(this.availableWorkers, 'id')
      } else {
        let workerNameOrWorkerPhoneFilter = this.workerNameOrWorkerPhoneFilter.trim().toLowerCase();
        let notDistinctAvailableWorkers = this.availableWorkers.filter(worker =>
            (worker.name && worker.name.trim().toLowerCase().indexOf(workerNameOrWorkerPhoneFilter) != -1) ||
            (worker.surname && worker.surname.trim().toLowerCase().indexOf(workerNameOrWorkerPhoneFilter) != -1) ||
            (worker.patronymic && worker.patronymic.trim().toLowerCase().indexOf(workerNameOrWorkerPhoneFilter) != -1) ||
            (worker.phone && worker.phone.trim().toLowerCase().indexOf(workerNameOrWorkerPhoneFilter) != -1)
        );

        workers = utils.distinctBy(notDistinctAvailableWorkers, 'id');
      }

      let workerMap = new Map();

      if (!!workers && workers.length > 0) {
        workers.forEach(w => {
          let district = w.endDistrictService;
          let workersWithDistrict = workerMap.get(district);
          if (!workersWithDistrict)
            workersWithDistrict = [];
          workersWithDistrict.push(w);
          workerMap.set(district, workersWithDistrict);
        });
      }

      return Array.from(workerMap);
    },

    serviceTime: {
      get () {
        return this.serviceArray.length > 0 ? utils.getFormattedTimeStringFromLongWithoutTimezone(this.serviceArray[0].date) : ''
      }
    },

    duration: {
      get () {
        return this.serviceArray.length > 0 ? utils.formatServiceDuration(this.serviceArray[0]) : ''
      }
    },

    name: {
      get () {
        return this.serviceArray.length > 0 ? this.serviceArray[0].name : ''
      }
    },

    count: {
      get () {
        return this.serviceArray.length
      }
    },

    selectedWorkers: {
      get () {
        return this.availableWorkers.filter(worker => worker.selected)
      }
    }
  },

  watch: {
    isVisible (val) {
      if (val) {
        this.serviceArray = this.serviceArrayFromOrder
        this.updateAvailableWorkers()
      }
    }
  },

  methods: {
    getShortAddress(address) {
      return address ? utils.getSmallAddressFromFull(address) : '';
    },

    getWorkerCategories (worker) {
      return worker.categories ? worker.categories.join(', ') : ''
    },

    updateAvailableWorkers () {
      let service = this.serviceArray[0]
      if (service.category.shippingPacking) {
        utils.spotDistrictByCoords(service.address.lat, service.address.lng, this.$store.getters.districts)
          .then(district => {
            service.startDistrict = district
            service.endDistrict = district
            service.startRegion = utils.spotRegionByCoords(service.address.lat, service.address.lng, this.$store.getters.regions)
            service.endRegion = service.startRegion
          })
          .then(this.getWorkers(service))
      } else { this.getWorkers(service) }
    },

    getWorkers (service) {
      if (service.type == 'OrderToPetrol'
        || service.type == 'OrderToDowntime'
        || (service.type == 'OrderToAdditional' && !service.category.shippingPacking)) {
        let availableWorkers = this.workersOnCurrentOrder
          .map(worker => this.createWorkerData(worker));

        if (service.type == 'OrderToDowntime') {
          availableWorkers = availableWorkers
            .filter(worker => worker.type.code == 'driver')
        } else if (service.type == 'OrderToAdditional') {
          let workerTypes = service.category.workerTypes.trim().split(',');
          workerTypes = workerTypes.map(workerType => workerType.trim());

          let workerTypeCodes = [];
          if (workerTypes.indexOf('Водители') != -1
            && workerTypes.indexOf('Водители') != workerTypes.indexOf('Водители мусоровоза')) {
            workerTypeCodes.push('driver');
          }
          if (workerTypes.indexOf('Грузчики') != -1) {
            workerTypeCodes.push('mover');
          }
          if (workerTypes.indexOf('Мебельщики') != -1) {
            workerTypeCodes.push('furniture');
          }
          if (workerTypes.indexOf('Водители мусоровоза') != -1) {
            workerTypeCodes.push('garbage');
          }

          if (workerTypeCodes.length > 0) {
            availableWorkers = availableWorkers
              .filter(worker => workerTypeCodes.indexOf(worker.type.code) != -1);
          }
        }

        this.availableWorkers = availableWorkers
          .map(worker => {
            let isAlreadyBusy = this.isWorkerAlreadyBusyOnCurrentService(worker)

            return Object.assign(worker, {
              selected: isAlreadyBusy
            })
          })
      } else {
        let workersOnThisServiceArray = []
        this.serviceArray.forEach(s => {
          if (s.worker) workersOnThisServiceArray.push(s.worker)
        })

        api
          .getAvailableWorkers(service.type, this.categoryId, service.date,
            service.startRegion, service.endRegion, service.startDistrict, service.endDistrict, this.isCash,
            (service.clientTime ? service.clientTime : 0))
          .then(availableWorkers => {
            if (availableWorkers) {
              this.availableWorkers = workersOnThisServiceArray
                .concat(
                  availableWorkers
                    .filter(worker => this.type == 'shippingPacking' || !this.isWorkerAlreadyBusyOnOtherService(worker))
                    .filter(aw => !this.isWorkerAlreadyBusyOnCurrentService(aw))
                    .concat(this.type == 'shippingPacking' ? this.workersOnCurrentOrder
                      .filter(w => {
                        for (let aw of availableWorkers) {
                          if (aw.id == w.id) { return false }
                        }
                        return true
                      })
                      : [])
                )
                .map(worker => {
                  let isAlreadyBusy = this.isWorkerAlreadyBusyOnCurrentService(worker);
                  return Object.assign(this.createWorkerData(worker), {
                    selected: isAlreadyBusy
                  })
                })
            }
          })
      }
    },

    isWorkerAlreadyBusyOnCurrentService (worker) {
      for (let s of this.serviceArray) {
        if (s.worker && s.worker.id == worker.id) { return true }
      }
      return false
    },

    isWorkerAlreadyBusyOnOtherService (worker) {
      for (let gs of this.$store.getters.groupedServices) {
        if (!utils.compareGroupedServices(gs[0], this.serviceArray[0]) &&
            gs.filter(s => !s.category.shippingPacking &&
              s.worker && s.worker.id == worker.id)
              .length > 0) {
          return true
        }
      }
      return false
    },

    createWorkerData (worker) {
      return {
        id: worker.id,
        name: worker.name,
        surname: worker.surname,
        patronymic: worker.patronymic,
        phone: worker.phone,
        balance: worker.balance,
        rating: worker.rating,
        startingDebt: worker.startingDebt,
        completedService: worker.completedService,
        endDistrictService: worker.endDistrictService,
        address: worker.address,
        endOfService: worker.endOfService,
        type: {
          // TODO передавать в WorkerSmallDto type как объект
          code: (typeof worker.type === 'object' ? worker.type.code : worker.type)
        },
        categories: worker.categories
      }
    },

    addOrRemoveWorker(worker) {
      if (worker.selected) {
        worker.selected = false
      } else if (this.selectedWorkers.length >= this.serviceArray.length) {
        event.preventDefault();
        alert('Свободного места для рабочего нет');
      } else {
        worker.selected = true
      }
    },

    appoint () {
      let serviceArrayIndex = this.serviceArrayIndex
      let sortedSelectedWorkers = this.selectedWorkers.map(selectedWorker => {
        let workerData = Object.assign({}, selectedWorker)
        delete workerData.selected
        return workerData
      })

      this.$store.commit('updateWorkersInGroupedServiceByIndex', {
        index: serviceArrayIndex,
        workers: sortedSelectedWorkers
      })

      this.closeWindow()
    },

    closeWindow () {
      this.$emit('close-window', false)
    }
  }
}
</script>
